'use strict';
module.exports = function isEventEphemeral(cmd, args) {
	return cmd === 'updateAttr' && args && Array.isArray(args) && 'collapsed' === args[1];
};

